import React from 'react'

const AboutUs = () => {
  
  const Gouravgarg = 'https://res.cloudinary.com/custoshoe7/image/upload/v1696405069/ns1koxdgpdd6vvyn8on7.jpg'
const GouriGoel = 'https://res.cloudinary.com/custoshoe7/image/upload/v1696405068/p1i2llfnex67n82n1rju.jpg'
  const email = 'custoshoe7@gmail.com';
  return (
    <div className="mt-3">
      <div className='font-serif text-8xl'>About Us</div>
    {/* founder */}
    <div className="mt-3">
    {/*  */}
    {/* dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700  */}
      <div class="flex flex-col items-center mx-auto md:ml-20 bg-white border border-gray-200 rounded-lg shadow md:flex-row md:max-w-3xl hover:bg-gray-100">
          <img class="object-cover w-full rounded-t-lg h-96 md:h-100 md:w-50 md:rounded-none md:rounded-l-lg" src={Gouravgarg} alt=""/>
          <div class="flex flex-col justify-between p-4 leading-normal">
              <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900">Gourav Garg</h5>
              <p class="mb-3 font-normal text-gray-700 dark:text-gray-400">I'm Gourav, the CEO of the company. My primary emphasis is on team management and maintaining a cohesive team environment, while also being involved in the design aspects of our work. The passion for playing with colors and designs inspired me to launch this venture.</p>

              <a href={`mailto:${email}`} target="_blank" rel="noopener noreferrer">
                Contact Us
              </a>
          </div>
      </div>

      <div class="flex flex-col-reverse items-center mx-auto md:mr-20 mt-5 bg-white border border-gray-200 rounded-lg shadow md:flex-row md:max-w-3xl hover:bg-gray-100">
          <div class="flex flex-col justify-between p-4 leading-normal">
              <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900">Gouri Goel</h5>
              <p class="mb-3 font-normal text-gray-700 dark:text-gray-400">I'm Gauri, the Chief Operating Officer of the company. My primary responsibilities revolve around company management and promoting our brand on social media platforms.</p>
              <a href={`mailto:${email}`} target="_blank" rel="noopener noreferrer">
                Contact Us
              </a>
          </div>
          <img class="object-cover w-full rounded-t-lg h-96 md:h-100 md:w-50 md:rounded-none md:rounded-l-lg" src={GouriGoel} alt=""/>

      </div>

      
      
    </div>
    {/* co-founder */}
    <div>
      <div className='grid grid-cols-1 gap-2 md:grid-cols-4 my-6 md:max-w-8xl w-11/12 mx-auto'>
        <div>
          <img
              alt="gallery"
              className=" h-full w-full rounded-lg object-cover object-center"
              src="https://res.cloudinary.com/custoshoe7/image/upload/v1696406153/tn9x8cbszgh38agwwwz7.jpg" />
        </div>
        <div>
          <img
              alt="gallery"
              className=" h-full w-full rounded-lg object-cover object-center"
              src="https://res.cloudinary.com/custoshoe7/image/upload/v1696406157/lcmkbrmicnv9yeazhjbx.jpg" />
        </div>
        <div className='col-span-2'>
          <img
              alt="gallery"
              className=" h-full w-full rounded-lg object-cover object-center"
              src="https://res.cloudinary.com/custoshoe7/image/upload/v1696406154/b76i1skbulmfe0mlx9va.jpg" />
        </div>
        <div className='col-span-2'>
          <img
              alt="gallery"
              className=" h-full w-full rounded-lg object-cover object-center"
              src="https://res.cloudinary.com/custoshoe7/image/upload/v1696405069/ysvewngb9hlyimocfpjx.jpg" />
        </div>
        <div>
          <img
              alt="gallery"
              className=" h-full w-full rounded-lg object-cover object-center"
              src="https://res.cloudinary.com/custoshoe7/image/upload/v1696406164/hzkeoo3kmzsenylxhd7d.jpg" />
        </div>
        <div>
          <img
              alt="gallery"
              className=" h-full w-full rounded-lg object-cover object-center"
              src="https://res.cloudinary.com/custoshoe7/image/upload/v1696406158/gsdsylyunco4mequyt3s.jpg" />
        </div>
        <div>
          <img
              alt="gallery"
              className=" h-full w-full rounded-lg object-cover object-center"
              src="https://res.cloudinary.com/custoshoe7/image/upload/v1696406306/enisu1fuqlpiqy5ahc9z.jpg" />
        </div>
        <div>
          <img
              alt="gallery"
              className=" h-full w-full rounded-lg object-cover object-center"
              src="https://res.cloudinary.com/custoshoe7/image/upload/v1696406295/ha95odamlsdlpsqassik.jpg" />
        </div>
        <div className='col-span-2'>
          <img
              alt="gallery"
              className=" h-full w-full rounded-lg object-cover object-center"
              src="https://res.cloudinary.com/custoshoe7/image/upload/v1696406161/awqlnkoprv4ijwzgbkxo.jpg" />
        </div>

      
      </div>
    </div> 
    {/* galery */}
  

    </div>
  )
}

export default AboutUs